import { faArrowRight, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Backdrop, Button } from '@mui/material'
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react'


import '../../../../../components/popup/ConfigComparePopup.css';
import { MarginContainer } from '../../../../manageUpdateAccess/ManageUpdateAccess';
import DefaultHeading from '../../../../../components/heading/DefaultHeading';
import BorderHeading from '../../../../../components/heading/BorderHeading';
import QuestionHeading from '../../../../../components/heading/QuestionHeading';
import { ConfigComparePopupProps } from '../../../../../types/types';

function NewConfigComparePopup(props: ConfigComparePopupProps) { // curConfig and newConfig are arrays of configs
    const [newAddedConfigs, setNewAddedConfigs] = useState<any[]>([]);
    const [deletedConfigs, setdeletedConfigs] = useState<any[]>([]);
    const [updatedConfigs, setUpdatedConfigs] = useState<any[]>([]);
    const popupContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.showConfigPopup) {
            if (popupContainerRef.current) {
                popupContainerRef.current.scrollTop = 0;
            }
            const deletedObjArr = [];
            const newObjArr = [];
            const updatedObjArr = [];

            const configKeys = Object.keys(props.curConfig);

            for (let configNum = 0; configNum < configKeys.length; configNum++) {
                for (const curConfigObj of (props.curConfig[configKeys[configNum]] ?? [])) {
                    const editedObj = (props.newConfig[configKeys[configNum]] ?? []).find((obj: any) => obj.name === curConfigObj.name);
                    if (!editedObj) {
                        // Object is deleted
                        deletedObjArr.push({
                            curConfigObj,
                            newConfigObj: "-"
                        });
                    } else {
                        // Object is either updated or unchanged
                        const hasChanged = !(_.isEqual(curConfigObj, editedObj));
                        if (hasChanged) {
                            // Object is updated
                            updatedObjArr.push({
                                curConfigObj,
                                newConfigObj: editedObj
                            });
                        }
                    }
                }
                for (const editedObj of (props.newConfig[configKeys[configNum]] ?? [])) {
                    const currentObj = (props.curConfig[configKeys[configNum]] ?? []).find((obj: any) => obj.name === editedObj.name);

                    if (!currentObj) {
                        // Object is new
                        newObjArr.push({
                            curConfigObj: "-",
                            newConfigObj: editedObj,
                        });
                    }
                }
            }
            setNewAddedConfigs(newObjArr);
            setUpdatedConfigs(updatedObjArr);
            setdeletedConfigs(deletedObjArr);
        }
    }, [props.showConfigPopup])
    function handleConfirmClick() {
        props.setShowConfigPopup(false);
        props.onSuccess();
    }
    function closePopup() {
        if(props.onCancel){
            props.onCancel();
        }
        props.setShowConfigPopup(false);
    }
    function renderConfigKeyValue(configObj: any) {
        let finalValue = "";
        if (configObj.value !== undefined) {
            finalValue = configObj.value;
        } else {
            finalValue = configObj
        }
        return finalValue === "-" ? finalValue : JSON.stringify(finalValue, null, 2);
    }
    return (
        <Backdrop open={props.showConfigPopup} sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        >
            <div className='config-compare-popup-container'>
                <div className="config-compare-popup-cross-container">
                    <FontAwesomeIcon
                        className="otp_cross_button"
                        icon={faClose}
                        onClick={closePopup}
                    />
                </div>
                <div className='config-compare-default-heading'>
                    <DefaultHeading heading={props.message} showDefaultBackButton={false}>
                        <>
                            <Button className='config-compare-popup-disabled-button' variant="contained" onClick={closePopup}>Cancel</Button>
                            <Button variant="contained" onClick={handleConfirmClick}>Confirm</Button>
                        </>
                    </DefaultHeading>
                </div>
                <div className='config-compare-popup-boxes-container' ref={popupContainerRef}>
                    <div className='config-compare-popup-box'>
                        <BorderHeading>Updated Keys</BorderHeading>
                        {updatedConfigs.length === 0 && <div className="config-compare-no-keys-message">No updated keys</div>}
                        <div style={{ maxHeight: "40vh", overflow: "auto" }}>
                            {updatedConfigs.map((configStateObj: any, index: number) => {
                                return <MarginContainer key={index} margin="1.5rem">
                                    <QuestionHeading disableTextTransform={true}>{configStateObj.curConfigObj?.name}</QuestionHeading>
                                    <div className='config-compare-popup-values-container'>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-delete-background-color'>
                                                {renderConfigKeyValue(configStateObj.curConfigObj)}
                                            </div>
                                        </div>
                                        <div className='config-compare-popup-arrow-icon'><FontAwesomeIcon icon={faArrowRight} /></div>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-add-background-color'>
                                                {renderConfigKeyValue(configStateObj.newConfigObj)}
                                            </div>
                                        </div>
                                    </div>
                                </MarginContainer>
                            })}
                        </div>
                    </div>
                    <div className='config-compare-popup-box'>

                        <BorderHeading>Deleted Keys</BorderHeading>

                        {deletedConfigs.length === 0 && <div className="config-compare-no-keys-message">No deleted keys present</div>}
                        <div style={{ maxHeight: "40vh", overflow: "auto" }}>
                            {deletedConfigs.map((configStateObj: any, index: number) => {
                                return <MarginContainer key={index} margin="1.5rem">
                                    <QuestionHeading disableTextTransform={true}>{configStateObj.curConfigObj?.name}</QuestionHeading>
                                    <div className='config-compare-popup-values-container'>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-delete-background-color'>
                                                {renderConfigKeyValue(configStateObj.curConfigObj)}
                                            </div>
                                        </div>
                                        <div className='config-compare-popup-arrow-icon'><FontAwesomeIcon icon={faArrowRight} /></div>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-add-background-color'>
                                                {renderConfigKeyValue(configStateObj.newConfigObj)}
                                            </div>
                                        </div>
                                    </div>
                                </MarginContainer>
                            })}
                        </div>
                    </div>
                    <div className='config-compare-popup-box'>
                        <BorderHeading>New Added Keys</BorderHeading>
                        {newAddedConfigs.length === 0 && <div className="config-compare-no-keys-message">No new keys added</div>}
                        <div style={{ maxHeight: "40vh", overflow: "auto" }}>
                            {newAddedConfigs.map((configStateObj: any, index: number) => {
                                return <MarginContainer key={index} margin="1.5rem">
                                    <QuestionHeading disableTextTransform={true}>{configStateObj.newConfigObj?.name}</QuestionHeading>
                                    <div className='config-compare-popup-values-container'>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-delete-background-color'>
                                                {renderConfigKeyValue(configStateObj.curConfigObj)}
                                            </div>
                                        </div>
                                        <div className='config-compare-popup-arrow-icon'><FontAwesomeIcon icon={faArrowRight} /></div>
                                        <div className='config-compare-popup-cur-prev-value-container'>
                                            <div className='config-compare-popup-value-container config-compare-add-background-color'>
                                                {renderConfigKeyValue(configStateObj.newConfigObj)}
                                            </div>
                                        </div>
                                    </div>
                                </MarginContainer>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Backdrop>
    )
}

export default NewConfigComparePopup